<div class="open-registration-search">
  <div class="open-registration-search__input">
    <se-fe-toolbar
      [seFeDataQuery]="searchTerm"
      [seFeDataSearchDebounce]="300"
      [seFeDataSearchMinLength]="1"
      [seFeDataSearchPlaceholder]="'REGISTRATIONS.search_placeholder' | translate"
      [seFeDataAriaLabel]="'REGISTRATIONS.search_placeholder' | translate"
      (seFeQueryChange)="handleSearchQueryChange($event)">
    </se-fe-toolbar>
  </div>
  <se-po-open-registration-filter
    class="open-registration-search__filters"
    [sports]="sports"
    [organizations]="organizations"
    (filtersChange)="handleFiltersChange($event)">
  </se-po-open-registration-filter>
</div>
